import React, { useEffect, useState } from "react";
import { REQUEST_TARGET_MODULES } from "../../../../Library/APIsTarget";
import moment from "moment";
import LoadingBtn from "../../../Widgets/LoadingBtn";
import { AlertNotif } from "../../../../Library/AlertNotif";
import { EncodeURIComponentSafe } from "../../../../Library/GlobalHelper";

export default function PreviewTimetables({ termid, courses }) {
  const current_day = moment();

  const [start_semester, setStart_semester] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const [has_conflict, setHasConflict] = useState(false);
  const [schd, setSchd] = useState({ loading: false, data: [], message: "" });
  const [unmatchedSchedules, setUnmatchedSchedules] = useState([]);
  const [daysArr, setDaysArr] = useState([]);
  const [groupedSchedules, setGroupedSchedules] = useState([]);
  const list_sectionid = courses
    ? courses
      .filter(item => item.action_type && item.action_type === "add")
      .map((c) => c?.section_id)
      .filter((id) => id !== undefined && id !== null)
      .join(",")
    : "";

  const GET_MILESTONE_START_SEMESTER = async (term_id, sections) => {
    try {
      setStart_semester({ loading: true, data: [], message: "" });
      setSchd({ loading: true, data: [], message: "" });
      const param = {
        atpid: term_id,
        view_all: 1,
      };
      const param_post = {
        parameters: param,
        target_data: "GET_ACAD_MSTONE_BY_ACAD",
      };

      const results = await REQUEST_TARGET_MODULES(param_post);
      if (results.data && Object.values(results.data).length > 0) {
        const key_semester_start = "asc.atp.milestone.FirstDayOfClasses";
        const find_by_key = results.data.find(
          (item) => item.mstone_type_id === key_semester_start
        );
        if (find_by_key) {
          const monday = moment(find_by_key?.start_dt || "")
            .startOf("weeks")
            .format("YYYY-MM-DD");
          const sunday = moment(find_by_key?.start_dt || "")
            .endOf("weeks")
            .format("YYYY-MM-DD");

          setStart_semester({ loading: false, data: find_by_key, message: "" });
          ReloadSchd(monday, sunday, sections);
        } else {
          const monday = moment(current_day)
            .startOf("weeks")
            .format("YYYY-MM-DD");
          const sunday = moment(current_day)
            .endOf("weeks")
            .format("YYYY-MM-DD");
          const daysArray = generateDaysArray(monday, sunday);
          setDaysArr(daysArray);
          setStart_semester({ loading: false, data: [], message: "" });
          setUnmatchedSchedules(courses);
          setSchd({ loading: false, data: [], message: "" });
        }
      } else {
        const monday = moment(current_day)
          .startOf("weeks")
          .format("YYYY-MM-DD");
        const sunday = moment(current_day).endOf("weeks").format("YYYY-MM-DD");
        const daysArray = generateDaysArray(monday, sunday);
        setDaysArr(daysArray);
        setUnmatchedSchedules(courses);
        setStart_semester({ loading: false, data: [], message: "" });
        setSchd({ loading: false, data: [], message: "" });
      }
    } catch (error) {
      setSchd({ loading: true, data: [], message: error?.message });
    }
  };

  useEffect(() => {
    if (termid && list_sectionid) {
      try {
        GET_MILESTONE_START_SEMESTER(termid, list_sectionid);
      } catch (error) {
        setSchd({ loading: false, data: [], message: error?.message });
      }
    }
  }, [termid, list_sectionid]);

  const ReloadSchd = async (start_dt, end_dt, sections) => {
    setSchd({ loading: true, data: [], message: "" });
    const param = {
      grouped: "True",
      start_dt,
      end_dt,
      section_id: EncodeURIComponentSafe(sections),
    };
    const param_post = {
      parameters: param,
      target_data: "GET_SCHD",
    };

    const results = await REQUEST_TARGET_MODULES(param_post);
    if (results.data && Object.values(results.data).length > 0) {
      const data_schd = results.data.map((item) => ({
        start_dt: item?.start_dt,
        end_dt: item?.end_dt,
        start_day: moment(item?.start_dt).format("dddd"),
        end_day: moment(item?.end_dt).format("dddd"),
        coursetitle: item?.course?.coursetitle || "",
        coursecredit: item?.course?.credit || "",
        coursecode: item?.course?.code || "",
        section_id: item?.section_id || "",
        is_conflict: false,
      }));

      const data_schedule_sections = data_schd.map((s) => s?.section_id);
      const unmatched = compareSchedulesWithCourses(
        data_schedule_sections,
        courses.filter(item => item.action_type && item.action_type === "add")
      );
      setUnmatchedSchedules(unmatched);

      const { conflicts, updatedSchedules } = checkScheduleConflicts(data_schd);
      if (conflicts.length > 0) {
        setSchd({
          loading: false,
          data: updatedSchedules,
          message: "",
        });
        setHasConflict(true);
      } else {
        setSchd({ loading: false, data: updatedSchedules, message: "" });
        setHasConflict(false);
      }

      const daysArray = generateDaysArray(start_dt, end_dt);
      setDaysArr(daysArray);
      const groupedSchedules = groupSchedulesByDay(
        start_dt,
        end_dt,
        updatedSchedules
      );
      setGroupedSchedules(groupedSchedules);
      setSchd({ loading: false, data: updatedSchedules, message: "" });
    } else {
      setSchd(results);
      const monday = moment(current_day).startOf("weeks").format("YYYY-MM-DD");
      const sunday = moment(current_day).endOf("weeks").format("YYYY-MM-DD");
      const daysArray = generateDaysArray(monday, sunday);
      setDaysArr(daysArray);
      setUnmatchedSchedules(courses);
      setGroupedSchedules([]);
    }
  };

  return (
    <div>
      <div className="table-responsive" id="table-timetables">
        <table className="table table-borderless table-vertical-center">
          <thead>
            <tr
              className="text-center text-uppercase "
              style={{ backgroundColor: "#f0f6fe" }}
            >
              {daysArr &&
                Object.values(daysArr).length > 0 &&
                daysArr.map((day, index) => (
                  <th
                    key={index}
                    className="text-center"
                    style={{ width: "150px" }}
                  >
                    <div className="font-weight-bolder font-size-lg">
                      {day.dayName}
                    </div>
                  </th>
                ))}
            </tr>
          </thead>
          <tbody>
            {schd.loading ? (
              <tr>
                <td colSpan={7}>
                  <LoadingBtn />
                </td>
              </tr>
            ) : schd.message ? (
              <tr>
                <td colSpan={7}>
                  <AlertNotif color="danger" message={schd.message} />
                </td>
              </tr>
            ) : daysArr && Object.values(daysArr).length > 0 ? (
              <tr>
                {daysArr.map((day, dayIndex) => {
                  const daySchedules = (
                    groupedSchedules[day.dayName] || []
                  ).sort((a, b) => {
                    const startA = moment(a.start_dt);
                    const startB = moment(b.start_dt);
                    return startA.diff(startB);
                  });

                  return (
                    <td key={dayIndex} className="align-top p-2">
                      {daySchedules.length > 0 ? (
                        <div className="d-flex flex-column gap-2">
                          {daySchedules.map((schedule, scheduleIndex) => (
                            <div
                              key={scheduleIndex}
                              className={`mb-2 rounded p-2 ${schedule.is_conflict === true
                                ? "text-danger bg-light-danger border border-danger"
                                : "text-dark border bg-light"
                                }`}
                            >
                              <div className="d-flex align-items-start">
                                <div className="mr-3">
                                  <span className="font-weight-bolder h1">
                                    ·
                                  </span>
                                </div>
                                <div>
                                  <span className="font-weight-bolder">
                                    <span className="d-block">
                                      {moment(schedule?.start_dt).format(
                                        "HH:mm A"
                                      )}{" "}
                                      -{" "}
                                      {moment(schedule?.end_dt).format(
                                        "HH:mm A"
                                      )}
                                    </span>
                                    <span>{schedule?.coursetitle}</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p className="mb-0 text-center">-</p>
                      )}
                    </td>
                  );
                })}
              </tr>
            ) : (
              <tr>
                <td colSpan={7}>No record found</td>
              </tr>
            )}
          </tbody>
          <tfoot>
            {has_conflict ? (
              <tr>
                <td colSpan={7} className="px-8" style={{ backgroundColor: "#f0f6fe" }}>
                  <span className="d-block font-weight-bold">Notes:</span>
                  <div className="d-flex align-items-center">
                    <div
                      className="p-3 rounded bg-danger"
                      style={{ width: "15px" }}
                    ></div>
                    <div className="font-weight-bolder ml-1 font-size-lg">
                      Time conflict. Please consult your counselor to report the
                      conflict and discuss a solution.
                    </div>
                  </div>
                </td>
              </tr>
            ) : ""}
            {unmatchedSchedules.length > 0 && (
              <tr>
                <td colSpan={7} className="p-2">
                  <div className="bg-light-warning p-5 rounded border border-warning">

                    <h4>Course Schedule Not Available</h4>
                    <span className="font-weight-bold font-size-lg">
                      The following course does not have a scheduled timetable
                      yet.
                    </span>

                    <div className="row mt-2">
                      {unmatchedSchedules.map((m, index) => (
                        <div className="col-auto p-1" key={index}>
                          <div className="border rounded bg-white p-3 ">
                            <span className="font-weight-bolder d-block">
                              {m?.detail?.coursetitle}
                            </span>
                            <span className="text-muted">
                              {m?.detail?.course_code}
                            </span>
                            <div className="border-top my-3"></div>
                            <div className="d-flex align-items-center justify-content-between">
                              <span className="d-block text-muted mr-2">{m?.section_id}</span>
                              <span className="badge badge-light">
                                {m?.detail?.course_credit} SKS
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </tfoot>
        </table>
      </div>
    </div>
  );
}

export const compareSchedulesWithCourses = (schedules, coursesSectionIds) => {
  const unmatched = coursesSectionIds.filter((schedule) => {
    return !schedules.includes(schedule.section_id);
  });

  return unmatched;
};

export const generateDaysArray = (start_date, end_date) => {
  if (!start_date || !end_date) return [];

  const days = [];
  let currentDate = moment(start_date);
  const endDate = moment(end_date);

  while (currentDate.isSameOrBefore(endDate)) {
    const dayName = currentDate.format("dddd");
    // Hanya tampilkan Senin - Sabtu
    if (dayName !== "Sunday") {
      days.push({
        date: currentDate.format("YYYY-MM-DD"),
        dayName: dayName,
        displayDate: currentDate.format("DD MMM"),
      });
    }
    currentDate.add(1, "day");
  }
  return days;
};

// Group schedules by day
export const groupSchedulesByDay = (start_date, end_date, data) => {
  const grouped = {};
  const days = generateDaysArray(start_date, end_date);

  // Initialize empty arrays for each day
  days.forEach((day) => {
    grouped[day.dayName] = [];
  });

  // Group schedules by their start_day
  data.forEach((schedule) => {
    if (grouped[schedule.start_day]) {
      grouped[schedule.start_day].push(schedule);
    }
  });

  return grouped;
};


export const checkScheduleConflicts = (schedules) => {
  const conflicts = [];
  const updatedSchedules = schedules.map(schedule => ({
    ...schedule,
    is_conflict: false
  }));

  // Group schedules by day
  const schedulesByDay = {};
  updatedSchedules.forEach((schedule, index) => {
    const day = schedule.start_day;
    if (!schedulesByDay[day]) {
      schedulesByDay[day] = [];
    }
    schedulesByDay[day].push({ ...schedule, originalIndex: index });
  });

  // Check conflicts within each day
  Object.keys(schedulesByDay).forEach(day => {
    const daySchedules = schedulesByDay[day];

    for (let i = 0; i < daySchedules.length; i++) {
      for (let j = i + 1; j < daySchedules.length; j++) {
        const schedule1 = daySchedules[i];
        const schedule2 = daySchedules[j];

        const start1 = moment(schedule1.start_dt);
        const end1 = moment(schedule1.end_dt);
        const start2 = moment(schedule2.start_dt);
        const end2 = moment(schedule2.end_dt);

        // Check if schedules overlap
        // Overlap occurs if: start1 < end2 AND start2 < end1
        const hasOverlap = start1.isBefore(end2) && start2.isBefore(end1);

        if (hasOverlap) {
          // Mark both schedules as conflicting
          updatedSchedules[schedule1.originalIndex].is_conflict = true;
          updatedSchedules[schedule2.originalIndex].is_conflict = true;

          conflicts.push({
            schedule1: {
              id: schedule1.id,
              course: schedule1.coursetitle,
              time: `${start1.format('HH:mm')} - ${end1.format('HH:mm')}`,
              day: schedule1.start_day
            },
            schedule2: {
              id: schedule2.id,
              course: schedule2.coursetitle,
              time: `${start2.format('HH:mm')} - ${end2.format('HH:mm')}`,
              day: schedule2.start_day
            }
          });
        }
      }
    }
  });

  return { conflicts, updatedSchedules };
};

export const calculateOverlapDuration = (start1, end1, start2, end2) => {
  const overlapStart = moment.max(start1, start2);
  const overlapEnd = moment.min(end1, end2);
  const duration = moment.duration(overlapEnd.diff(overlapStart));

  return {
    minutes: duration.asMinutes(),
    formatted: `${Math.floor(duration.asHours())}h ${duration.minutes()}m`,
  };
};
